import script from "./InsuranceClaimsEditPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./InsuranceClaimsEditPopUp.vue?vue&type=script&setup=true&lang=ts"

import "./InsuranceClaimsEditPopUp.vue?vue&type=style&index=0&id=a8ed123e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8ed123e"]])

export default __exports__